import { render } from "./MonthChart.vue?vue&type=template&id=cb567bf6"
import script from "./MonthChart.vue?vue&type=script&lang=js"
export * from "./MonthChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__